import { render, staticRenderFns } from "./org.vue?vue&type=template&id=10ee7e4f&"
import script from "./org.js?vue&type=script&lang=js&"
export * from "./org.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports